import store from '@/store';

export default (to, from, next) => {
    
    // Wait for Firebase to load before checking
    return store.dispatch('get_is_module_ufb_enabled')
        .catch(() => {
            // Suppress errors, will use default value
            console.log('  ⚠️ Firebase Remote Config error, using default')
        })
        .then(() => {
            const ufbEnabled = store.getters.is_show_ufb_module;
            const fwaEnabled = store.getters.is_show_fwa_module;
            const allow = ufbEnabled || fwaEnabled;
            

            return {
                allow,
                redirect: { name: 'not-found' },
            };
        });
}
